










import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { intervalToDuration } from "date-fns";
import useAuthUser from "@/hooks/useAuthUser";
import useNSFWUserSettings from "@/hooks/useNSFWUserSettings";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";
import BaseIcon from "@/components/BaseIcon";
import BaseSpinner from "@/components/BaseSpinner/BaseSpinner.vue";
import ConfirmSensitiveContent from "@/components/ConfirmSensitiveContent";
import { IMoreMenuItem } from "@/views/PageMore/config";

export default defineComponent({
  name: "MoreMenuItemNSFWUserSetting",
  components: { ConfirmSensitiveContent, BaseSpinner, BaseIcon },
  props: {
    item: { type: Object as PropType<IMoreMenuItem>, required: true },
  },
  setup() {
    const { authUserStrict } = useAuthUser();
    const { showNotSafeForWork, updateNSFWUserSettings } = useNSFWUserSettings();
    const showConfirm = ref(false);
    const processing = ref(false);

    const onClick = async () => {
      processing.value = true;
      const dateOfBirth = (
        await providers.PersonalInformationProvider.find({
          id: authUserStrict.value.id,
        })
      ).dateOfBirth;

      if (!dateOfBirth || (intervalToDuration({ start: new Date(dateOfBirth), end: new Date() }).years ?? 0) < 18) {
        showConfirm.value = true;
      } else {
        try {
          await updateNSFWUserSettings(!showNotSafeForWork.value);
        } finally {
          processing.value = false;
        }
      }
    };

    const onResolve = () => {
      showConfirm.value = processing.value = false;
    };

    const text = computed(() => (showNotSafeForWork.value ? $t("Not safe for work mode") : $t("Safe for work mode")));
    return {
      text,
      processing,
      showConfirm,
      onClick,
      onResolve,
    };
  },
});
